import { useNavigate } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { HiLocationMarker } from "react-icons/hi";
import { IoLocation, IoMail } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import Partner from '../../assets/icons/parnter.svg'
const Footer = () => {
    const navigate = useNavigate()
    return (
        <>
            <footer className="site-footer" id="footer">
                <div className="footer-top">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-12 wow fadeInUp footer_col" data-wow-delay="0.4s">
                                <div>
                                    <img src={require('assets/images/footer_logo.webp')} alt='Your Green Foods' className='footer_logo' loading='lazy' />
                                    <h5 className='footer_tagliner'>Your Green Foods - Bringing You Organic Millets, Oils & Natural Goodness.
                                    Choose Health, Choose Nature!</h5>
                                </div>
                                <div>
                                    <p className='fssai'>FSSAI : 12423030000800</p>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-3 col-12 wow fadeInUp footer_col" data-wow-delay="0.5s">
                                <div className="widget widget_getintuch">
                                    <h5 className="footer-title">Explore</h5>
                                    <ul>
                                        <li><p onClick={() => navigate('/support')}><span>Our Story</span></p></li>
                                        <li><p onClick={() => navigate('/faq')}><span>FAQs</span></p></li>
                                        <li><p onClick={() => navigate('/support')}><span>Support</span></p></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-3 col-md-3 col-12 wow fadeInUp footer_col" data-wow-delay="0.6s">
                                <div className="widget widget_services">
                                    <h5 className="footer-title">Quick Connect</h5>
                                    <ul>
                                        <li>
                                            <a>
                                                <IoLocation className='footer_outlet_ic' />
                                                <div className='ft_address'>
                                                    <p>
                                                        Sree Agencies - #112 / 1,
                                                        Battai Street, Karugambathur
                                                    </p>
                                                    <p>Vellore, Tamilnadu 632013</p>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a>
                                                <IoMail className='footer_outlet_ic' />
                                                <p className='footer_outlet_txt'>sreeagencies2020@gmail.com</p>
                                            </a>
                                            
                                        </li>
                                        <li>
                                            <a>
                                                <FaPhoneAlt className='footer_outlet_ic' />
                                                <p className='footer_outlet_txt'>
                                                        +91 9843-377-160
                                                        <br />
                                                        +91 6374-930-127
                                                    </p>

                                            </a>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-3 col-12 wow fadeInUp footer_col" data-wow-delay="0.7s">
                                <div className="widget widget_services ">
                                    <h5 className="footer-title">Our Products</h5>
                                    <ul>
                                        <li>
                                            <a
                                                href="/categories?id=65f56543b309f7f0d7103dca"
                                            >
                                                <HiLocationMarker className='footer_outlet_ic' />
                                                <p className='footer_outlet_txt'>Organic Millets</p>
                                            </a>
                                        </li>
                                        <li><a href="/categories?id=6602be9dc9ba6ac06dafe992">
                                            <HiLocationMarker className='footer_outlet_ic' /><p className='footer_outlet_txt'>Traditional Rices</p>
                                            </a>
                                        </li>
                                        <li><a href="/categories?id=65f7ef5a8e548e1c96b4ccc6">
                                            <HiLocationMarker className='footer_outlet_ic' /><p className='footer_outlet_txt'>Porridge Mix</p></a></li>

                                        <li><a href="/categories?id=6602c094c9ba6ac06dafe99e">
                                            <HiLocationMarker className='footer_outlet_ic' /><p className='footer_outlet_txt'>Millet Dosa Mix</p></a></li>
                                        <li><a href="/categories?id=6602c5dac9ba6ac06dafe9a6">
                                            <HiLocationMarker className='footer_outlet_ic' /><p className='footer_outlet_txt'>Puttu Mix</p></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="footer-bottom">
                        <div className="row">
                            <div className='col-xl-4'>
                                <p className='footer_sm_txts'>
                                    <span onClick={() => navigate('/privacy-policy')}>Privacy Policy | </span>
                                    <span onClick={() => navigate('/terms-and-conditions')}>Terms & Conditions</span>
                                </p>
                            </div>
                            <div className="col-xl-5 col-12 text-md-center">
                                <p>Copyright © 2024 Your Green Foods | Powered By <a href='https://iconicglobalsolution.com/' className="powered_by" target="_blank" rel='noreferrer'>Iconic Global Solution</a></p>
                            </div>
                            <div className='col-xl-3'>
                                <div className="social-icons">
                                    <a href="https://www.instagram.com/your_green_foods/" target="_blank" rel="noreferrer"><FaFacebookF className='footerIcon' /></a>
                                    <a href="https://www.instagram.com/your_green_foods/" target="_blank" rel="noreferrer"><FaInstagram className='footerIcon' /></a>
                                    <a href="https://wa.me/9843377160?text=Hello%20there!" target="_blank" rel="noreferrer"><FaWhatsapp className='footerIcon' /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>
        </>
    )
}

export default Footer;